"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.htmlCSS = exports.HTMLAdditionalCSS = exports.HTMLIndentCSS = void 0;
const util_1 = require("../../util");
const amendProvision_1 = require("./amendProvision");
const any_1 = require("./any");
const appdxItem_1 = require("./appdxItem");
const arithFormulaRun_1 = require("./arithFormulaRun");
const article_1 = require("./article");
const articleGroup_1 = require("./articleGroup");
const columnsOrSentencesRun_1 = require("./columnsOrSentencesRun");
const controlRun_1 = require("./controlRun");
const figRun_1 = require("./figRun");
const itemStruct_1 = require("./itemStruct");
const law_1 = require("./law");
const list_1 = require("./list");
const noteLike_1 = require("./noteLike");
const paragraphItem_1 = require("./paragraphItem");
const quoteStructRun_1 = require("./quoteStructRun");
const remarks_1 = require("./remarks");
const sentenceChildrenRun_1 = require("./sentenceChildrenRun");
const supplNote_1 = require("./supplNote");
const table_1 = require("./table");
const toc_1 = require("./toc");
exports.HTMLIndentCSS = [...(0, util_1.range)(0, 30)]
    .map(indent => /*css*/ `
.indent-${indent} {
    margin-left: var(--margin-left);
    --margin-left: ${indent}em;
}
`).join("\n");
exports.HTMLAdditionalCSS = `
`;
exports.htmlCSS = [
    exports.HTMLIndentCSS,
    exports.HTMLAdditionalCSS,
    any_1.HTMLAnyELsCSS,
    law_1.HTMLLawCSS,
    articleGroup_1.HTMLArticleGroupCSS,
    article_1.HTMLArticleCSS,
    paragraphItem_1.HTMLParagraphItemCSS,
    table_1.HTMLTableCSS,
    itemStruct_1.HTMLItemStructCSS,
    appdxItem_1.HTMLAppdxItemCSS,
    remarks_1.HTMLRemarksCSS,
    noteLike_1.HTMLNoteLikeCSS,
    list_1.HTMLListCSS,
    amendProvision_1.HTMLAmendProvisionCSS,
    supplNote_1.HTMLSupplNoteCSS,
    law_1.HTMLEnactStatementCSS,
    law_1.HTMLPreambleCSS,
    toc_1.HTMLTOCCSS,
    sentenceChildrenRun_1.HTMLSentenceChildrenRunCSS,
    columnsOrSentencesRun_1.HTMLColumnsOrSentencesRunCSS,
    figRun_1.HTMLFigRunCSS,
    arithFormulaRun_1.HTMLArithFormulaRunCSS,
    quoteStructRun_1.HTMLQuoteStructRunCSS,
    controlRun_1.HTMLControlRunCSS,
].join("\n");
exports.default = exports.htmlCSS;
//# sourceMappingURL=htmlCSS.js.map